import { render, staticRenderFns } from "./SpouseDetails.vue?vue&type=template&id=ee9e5b04"
import script from "./SpouseDetails.vue?vue&type=script&lang=js"
export * from "./SpouseDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports